abstract class SceneObjectTypeData {
    abstract readonly sceneObjectType: string;
}

export default SceneObjectTypeData;
